import { createSlice } from '@reduxjs/toolkit';

import { getPicklist } from "../../apis";
import { getInvoicesList, invoiceUploadFile, markPaymentStatus, updateInvoiceRemarks } from './api';

export const paymentManagement = createSlice({
  name: "paymentManagement",
  initialState: {
    loading: false,
    error: "",
    data: {
    },
    successMessage: false,
  },
  reducers: {
    clear: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInvoicesList.pending, (state, action) => {
      state.loading = true;
      state.data = []
    });
    builder.addCase(getInvoicesList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    });
    builder.addCase(getInvoicesList.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(markPaymentStatus.pending, (state, action) => {
        state.loading = true;
    })
    builder.addCase(markPaymentStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.data?.message ?? 'Request Successful'
    })
    builder.addCase(markPaymentStatus.rejected, (state, action) => {
        state.error = action.payload.message ?? 'Error'
        state.loading = false;
    })
    builder.addCase(invoiceUploadFile.pending, (state, action) => {
        state.loading = true;
    })
    builder.addCase(invoiceUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.data?.message ?? 'Request Successful'
    })
    builder.addCase(invoiceUploadFile.rejected, (state, action) => {
        state.error = action.payload.message ?? 'Error'
        state.loading = false;
    })
    builder.addCase(updateInvoiceRemarks.pending, (state, action) => {
        state.loading = true;
    })
    builder.addCase(updateInvoiceRemarks.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.data?.message ?? 'Remarks Saved Successfully'
    })
    builder.addCase(updateInvoiceRemarks.rejected, (state, action) => {
        state.error = action.payload.message ?? 'Error'
        state.loading = false;
    })
  },
});

export const { clear } = paymentManagement.actions;

export default paymentManagement.reducer